import React from 'react';
import './App.css';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import EnrollmentRequestsTable from './containers/EnrollmentRequestsTable';
import TablePagination from './components/Pagination';
import CSVUploadModal from './components/CSVUploadModal';

class App extends React.Component {
  constructor() {
    super();

    this.state = {
      data: {},
      page: 1,
    };
  }

  componentDidMount = async () => {
    const obj = {
      link: `/config.json`,
      object: {
        method: 'GET',
      },
    };

    await fetch(obj.link, obj.object)
      .then((response) => response.json())
      .then((data) => {
        localStorage.setItem('api_host', data.api_host);
      });

    // get code and state when redirected and auth token
    await this.getAutToken();
    this.getData();
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page) {
      this.getData();
    }
  };

  changePage = async (page) => {
    await this.setState({ page });
    // getData will be called by componentDidUpdate
  };

  getData = () => {
    const token = localStorage.getItem('authToken');
    const { page } = this.state;

    if (!token) return;

    this.setState({ data: {} });

    const apiHost = localStorage.getItem('api_host')

    const endpoint = `/api/infleet/vins?page=${page}&pageSize=5`;

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    headers.traceId = '00000000-0000-0000-0000-000000000000';
    headers.orgId = '00000000-0000-0000-0000-000000000000';

    const obj = {
      link: `${apiHost}${endpoint}`,
      object: {
        method: 'GET',
        headers,
      },
    };

    fetch(obj.link, obj.object)
        .then((response) => {
          if (response.status === 401 || response.status === 403) {
            console.error('Session expired:', response.status);
            this.logout();
          }

          return response;
        })
        .then((response) => response.json())
        .then((data) => this.setState({ data }))
        .catch((error) => {
          console.error('Error:', error);
        });
  };

  login = async (e) => {
    e.preventDefault();

    const apiHost = localStorage.getItem('api_host');

    const obj = {
      link: `${apiHost}/api/login/target`,
      object: {
        method: 'GET',
      },
    };

    await fetch(obj.link, obj.object)
      .then((response) => response.json())
      .then((data) => {
        window.location.href = data.url;
      });
  };

  getAutToken = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const code = urlParams.get('code');
    const state = urlParams.get('state');

    const apiHost = localStorage.getItem('api_host');

    if (code && state) {
      const obj = {
        link: `${apiHost}/api/login/exchange`,
        object: {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          },
          body: JSON.stringify({ authorizationCode: code, state: state }),
        },
      };

      await fetch(obj.link, obj.object)
        .then((response) => response.json())
        .then((data) => {
          localStorage.setItem('authToken', data.access_token);
          localStorage.setItem('expiresIn', data.expires_in);
          window.location.href = window.location.protocol + '//' + window.location.host;
        });
    }
  };

  logout = (e) => {
    if(e) e.preventDefault(); // Prevent reload of page
    localStorage.clear();
    const newURL =
      'https://idp.cloud.vwgroup.com/auth/realms/kums-mfa/protocol/openid-connect/logout?redirect_uri=' +
      window.location.protocol +
      '//' +
      window.location.host;
    window.location.href = encodeURIComponent(newURL);
  };

  render() {
    const { data } = this.state;
    const isLoggedIn = localStorage.getItem('authToken');
    return (
      <>
        <header>
          <Navbar bg="dark" variant="dark" className="navbar-custom">
            <Navbar.Brand href="/">
              CES ADMIN UI
              <Button
                  className="login-btn"
                  variant="secondary"
                  onClick={isLoggedIn ? this.logout : this.login}
              >
                {isLoggedIn ? 'Logout' : 'Login'}
              </Button>
            </Navbar.Brand>
          </Navbar>
        </header>

        {isLoggedIn ? (
            <section>
              <Container className="custom-container">
                <Card className="shadow p-3 mb-5 bg-white rounded">
                  <Card.Body>
                    <CSVUploadModal getData={this.getData} />

                    <EnrollmentRequestsTable
                        data={data}
                        getData={this.getData}
                        showModal={this.showModal}
                    />

                    {data.page && (
                        <TablePagination
                            page={data.page.page}
                            totalPages={data.page.totalPages}
                            changePage={this.changePage}
                        />
                    )}
                  </Card.Body>
                </Card>
              </Container>
            </section>
        ) : (
            <section>
              <Container className="custom-container">
                <h3 className="login-headline">
                  This application requires a login.
                </h3>
              </Container>
            </section>
        )}
      </>
    );
  }
}

export default App;
